import { render } from "./AboutUs.vue?vue&type=template&id=12d6202a&lang=pug"
import script from "./AboutUs.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutUs.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__